import React, { memo, PropsWithChildren } from 'react'

import { Text, TextProps } from '@surglogs-app/ui'

export const FormFieldValidationText = memo(
  (props: Omit<TextProps, 'ref' | 'children'> & PropsWithChildren) => (
    <Text
      {...{
        display: 'inline-block',
        variant: 'danger',
        role: 'alert',
        mt: 'sm',
        size: 'xxs',
        ...props,
      }}
    />
  ),
)
